var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArtIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlmnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#45B39C"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M507.216,305.253L356.293,154.331c-60-60-157.28-60-217.28,0 c-10.293,10.293-16.853,19.04-20.533,26.773c-31.093,47.147,38.293,56.053,91.52,100.32l-39.2,114.987 c-0.693,2.08,0.107,4.373,1.92,5.493l108.827,108.821C394.512,499.531,485.84,414.907,507.216,305.253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F6C358"
    },
    d: "M352.08,161.733c60.005,60.005,60.005,157.296,0,217.301 c-68.192,68.192-70.373-26.917-130.379-86.923s-156.208-61.088-86.917-130.379C194.789,101.728,292.075,101.728,352.08,161.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCD462"
    },
    d: "M356.309,154.336c60.005,60.005,60.005,157.296,0,217.301 c-68.192,68.192-70.373-26.912-130.379-86.917c-60.011-60.011-156.213-61.093-86.923-130.384 C199.013,94.331,296.304,94.331,356.309,154.336z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#DC8744"
    },
    cx: 167.584,
    cy: 181.867,
    r: 23.781
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 234.331,
    cy: 154.123,
    r: 23.781
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E56353"
    },
    cx: 308.155,
    cy: 166.987,
    r: 23.781
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#27A2DB"
    },
    cx: 352.267,
    cy: 223.067,
    r: 23.781
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#64798A"
    },
    cx: 352.267,
    cy: 294.4,
    r: 23.781
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#CE412D"
    },
    cx: 318.08,
    cy: 347.947,
    r: 23.781
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC8744"
    },
    d: "M241.275,189.595l-70.469,206.8c-0.827,2.432,0.432,5.083,2.843,5.973 c2.411,0.896,5.093-0.293,6.048-2.677l81.387-202.747L241.275,189.595z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.924,
    y: 174.837,
    transform: "matrix(0.9376 0.3476 -0.3476 0.9376 79.9517 -76.9676)",
    style: {
      fill: "#EBF0F3"
    },
    width: 21.13,
    height: 19.018
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64798A"
    },
    d: "M270.987,166.357c-1.488-1.531-3.136-3.371-5.269-3.253c-1.088,0.059-2.075,0.651-3.147,0.827 c-2.059,0.347-4.267-1.072-4.811-3.088c-0.267-0.992-0.171-2.059-0.491-3.035c-0.048-0.144-0.139-0.277-0.213-0.416 c-4.795,4.464-8.576,7.397-9.888,10.928c-0.848,2.283-0.949,4.651-0.48,6.869l19.68,7.296c1.803-1.376,3.269-3.237,4.117-5.525 c0.629-1.696,1.163-5.355,1.547-9.68C271.685,166.965,271.312,166.688,270.987,166.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56353"
    },
    d: "M257.76,160.843c0.544,2.016,2.752,3.435,4.811,3.088c1.072-0.181,2.064-0.768,3.147-0.827 c2.128-0.123,3.776,1.723,5.269,3.253c0.325,0.336,0.699,0.613,1.04,0.928c1.067-12.091,0.928-29.573-1.824-25.333 c-4.592,7.083-9.211,11.771-13.152,15.44c0.075,0.139,0.165,0.272,0.213,0.416C257.589,158.784,257.493,159.851,257.76,160.843z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArtIcon);
export default __webpack_public_path__ + "static/media/art_icon.9a567527f47975bbf49aef3032dc29e3.svg";
export { ForwardRef as ReactComponent };